/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_EmptyInputs */

const vi_cashflow_empty = /** @type {(inputs: Cashflow_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu trong kỳ`)
};

/**

* @param {Cashflow_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_empty = /** @type {((inputs?: Cashflow_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_empty(inputs)
});